export enum UnknownFilterSelectors {
    'UnknownRegion' = 'Kommune ikke oplyst',
    'UnknownGender' = 'Køn ikke oplyst',
    'UnknownAgeRange' = 'Alder ikke oplyst',
  }
  